<div class="product-img-viewer">
    <div class="det-default-selected-product-img">
        <img #image [src]="previewImage" class="product-primary-img" alt="product-img" />
    </div>
    @if (images.length > 1) {
        <div class="thumbnail-vertical-panel">
            <div class="image-viewer-prev-control prev-btn" (click)="prevImage()"></div>
            <ul class="thumbnail-vertical-list">
                @for (img of images; track img.image; let i = $index) {
                    <li class="det-default-thumbnail-list-item" [class.det-default-thumbnail-list-item-active]="i === currentIndex" (click)="updateActiveThumbnail(i, images[i]!.image)">
                        <img [src]="img.image" class="thumbnail-img" alt="thumbnail" />
                    </li>
                }
            </ul>
            <div class="image-viewer-next-control next-btn" (click)="nextImage()"></div>
        </div>
    }
</div>